import {theme} from '@/assets/styles/element-variables.scss'
import defaultSettings from '@/settings'
const { tagsView, fixedHeader, sidebarLogo, uniqueOpened, showFooter, footerTxt, caseNumber , caseNumbers } = defaultSettings

const settings = {
  state: {
    // theme: variables.theme,
    showSettings: false,
    tagsView: tagsView,
    fixedHeader: fixedHeader,
    sidebarLogo: sidebarLogo,
    uniqueOpened: uniqueOpened,
    showFooter: showFooter,
    footerTxt: footerTxt,
    caseNumber: caseNumber,
    caseNumbers:caseNumbers,
    toggleSearch: false,
    showDetailMenu: false,
  },
  mutations: {
    CHANGE_SETTING: (state, { key, value }) => {
      if (state.hasOwnProperty(key)) {
        state[key] = value
      }
    },
    TOOGLE_SEARCH: (state) => {
      state.toggleSearch = !state.toggleSearch
    },
    SHOW_DETAIL_MENU: (state,newShowDetailMenu) => {
      state.showDetailMenu = newShowDetailMenu
    }
  },
  actions: {
    changeSetting({ commit }, data) {
      commit('CHANGE_SETTING', data)
    },
    setToggleSearch({ commit }) {
      commit('TOOGLE_SEARCH')
    },
    setShowDetailMenu({ commit }) {
      commit('SHOW_DETAIL_MENU')
    }
  }
}

export default settings
